import React, { useState, useMemo } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { getSpecializations } from 'src/services/specializations.service';
import { useQuery } from 'react-query';
import PulseLoader from '../loaders/PulseLoader';
import { useSearchParams } from 'react-router-dom';
import ErrorIcon from '@mui/icons-material/Error';
import {
  columnsArray,
  getFilterModel,
  getPaginationModel,
  getSortModel,
  handleFilter,
  handlePagination,
  handleSort
} from 'src/components/RequestsGrid/requestGridUtils';
import { Typography } from '@material-ui/core';
import { useRecoilValue } from 'recoil';
import { userAtom } from '../../atoms/user';

export default function RequestsGrid({ queryId, query, onRowClick }) {
  const [columns, setColumns] = useState(columnsArray);
  const [urlParams, setUrlParams] = useSearchParams();
  const paginationModel = useMemo(() => getPaginationModel(urlParams), [urlParams]);
  const user = useRecoilValue(userAtom);
  //This state is to avoid infinite re-renders
  const [prevModel, setPrevModel] = useState({});
  const { isLoading: isSpecializationsLoading, isError: isSpecializationsError } = useQuery(
    'specializations',
    () => getSpecializations(),
    {
      onSettled: (data) => {
        columnsArray[3].valueOptions = data?.data?.map((s) => s.specialization_description);
        setColumns(columnsArray);
      }
    }
  );
  const {
    isLoading: isRequestsLoading,
    isError: isRequestsError,
    data: requests
  } = useQuery([...queryId, urlParams.toString()], () =>
    query({
      params: urlParams
    })
  );
  if (isRequestsError || isSpecializationsError)
    return (
      <div style={{ height: '50vh', width: '100%' }}>
        <Typography>
          <center>
            <h3>
              Something went wrong! <br /> Please try again or contact your adminstrator.
            </h3>

            <ErrorIcon color="error" style={{ fontSize: 100 }} />
          </center>
        </Typography>
      </div>
    );
  return (
    <div style={{ height: '50vh', width: '100%' }}>
      <DataGrid
        slots={{
          loadingOverlay: () => (
            <div style={{ height: '30vh', width: '100%' }}>
              <PulseLoader />
            </div>
          )
        }}
        // getRowClassName={(params) =>
        //   user.role === 'ADMIN' && params.row.admin_reviewed ? 'has-comments-request' : ''
        // }
        slotProps={{
          filterPanel: {
            sx: {
              '& .MuiDataGrid-filterFormValueInput': { width: 250 }
            }
          },
          pagination: {
            classes: null
          }
        }}
        initialState={{
          paginationModel: {
            page: 0,
            pageSize: 10
          }
        }}
        rows={requests?.data?.requests || []}
        rowCount={requests?.data?.count || 0}
        columns={columns}
        loading={isSpecializationsLoading || isRequestsLoading}
        onRowClick={(e) => onRowClick(e.id)}
        filterDebounceMs={1000}
        filterMode="server"
        filterModel={getFilterModel(urlParams)}
        onFilterModelChange={(model) => {
          handleFilter(model, urlParams, setUrlParams, prevModel, setPrevModel);
        }}
        paginationMode="server"
        pagination
        paginationModel={paginationModel}
        onPaginationModelChange={(model) => {
          handlePagination(model, urlParams, setUrlParams);
        }}
        pageSizeOptions={[10, 15, 20, 25]}
        sortingMode="server"
        sortModel={getSortModel(urlParams)}
        onSortModelChange={(model) => {
          handleSort(model, urlParams, setUrlParams);
        }}
      />
    </div>
  );
}
